
import Dashboard from "../screens/dashboard";
import Breadcrumbs from "../components/breadcrumbs/CHBreadcrubs";
export interface IRouteData {
  title: string;
  path: string;
  element?: any;
  icon?: any;
  visible: boolean;
  children?: IRouteData[];
  breadcrumb?: any;
  props?: any;
  edit?: boolean;
  delete?: boolean;
  add?: boolean;
}


const RouteData: IRouteData[] = [
  {
    title: "Marketing acquisition",
    path: "marketing",
    visible: true,
    children: [
      {
        title: "Articles",
        path: "articles",
        visible: true,
        icon: "articlesIcon",
        element: "articles",
        edit: false,
        delete: false,
        add: false,
      },
      {
        title: "News",
        path: "news",
        visible: true,
        icon: "bookIcon",
        element: "news",
        edit: false,
        delete: false,
        add: false,
      },
    ],
  },

  {
    title: "Control",
    path: "control",
    visible: true,
    children: [
      {
        title: "Users",
        path: "users",
        visible: true,
        icon: "usersIcon",
        children: [
          {
            title: "User edit",
            path: ":id",
            visible: false,
            element: "userEdit",
            props: { param: "id" },
            children: [
              {
                title: "User edit calc",
                path: ":calc",
                visible: false,
                element: "calcPage",
                breadcrumb: Breadcrumbs,
                props: { param: "calc" },
              },
            ],
          },
        ],
        element: "users",
        edit: false,
        delete: false,
        add: false,
        
      },
      {
        title: "Property Reports",
        path: "property-reports",
        visible: true,
        icon: "calcIcon",
        element: "propertyReports",
        edit: false,
        delete: false,
      },
      {
        title: "User Enquiry",
        path: "enquiry",
        visible: true,
        icon: "articlesIcon",
        element: "userEnquiry",
        edit: false,
        delete: false,
      },
      {
        title: "Assign Roles",
        path: "assignRoles",
        visible: true,
        icon: "articlesIcon",
        element: "subAdmin",
        edit: false,
        delete: false,
        add: false,
      },

    ],
  },

  {
    title: "Site Settings",
    path: "site",
    visible: true,
    children: [
      {
        title: "Site Settings",
        path: "site-settings",
        visible: true,
        icon: "articlesIcon",
        element:"siteSettings",
        edit: false,
      },
    ],
  },

  {
    title: "Page management ",
    path: "pages",
    visible: true,
    children: [
      // {
      //   title: "User Enquiry",
      //   path: "enquiry",
      //   visible: true,
      //   icon: "articlesIcon",
      //   element: <UserEnquiry />,
      // },
      {
        title: "FAQ",
        path: "faq",
        visible: true,
        icon: "faq",
        element: "faq",
        edit: false,
        delete: false,
      },
      {
        title: "Team",
        path: "team",
        visible: true,
        icon: "team",
        element: "team",
        edit: false,
        delete: false,  
      },
      {
        title: "Contact Details",
        path: "contactDetails",
        visible: true,
        icon: "contactDetails",
        element: "contactDetails",
        edit: false,
        delete: false,
      },
      {
        title: "Privacy Policy",
        path: "privacyPolicy",
        visible: true,
        icon: "articlesIcon",
        element: "privacyPolicy",
        edit: false,
        delete: false,
      },
      {
        title: "Refinance",
        path: "refinance",
        visible: true,
        icon: "articlesIcon",
        element: "refinance",
        edit: false,
        delete: false,
      },
      {
        title: "Next home",
        path: "next-home",
        visible: true,
        icon: "bookIcon",
        element: "nextHome",
        edit: false,
        delete: false,
      },
      {
        title: "Invest in property",
        path: "invest",
        visible: true,
        icon: "articlesIcon",
        element: "invest",
        edit: false,
        delete: false,
      },
      {
        title: "First home buyer",
        path: "first-home",
        visible: true,
        icon: "bookIcon",
        element: "firstHome",
        edit: false,
        delete: false,
      },
      {
        title: "Construction loan",
        path: "construction",
        visible: true,
        icon: "construction",
        element: "construction",
        edit: false,
        delete: false,
      },
    ],
  },

  {
    title: "404",
    path: "*",
    element: Dashboard,
    visible: false,
    icon: "404",
  },
];

export default RouteData;
